import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '@cpd-app/state';
import * as FavoriteOccupationsActions from './favorite-occupations.actions';
import * as FavoriteOccupationsSelectors from './favorite-occupations.selectors';

@Injectable({
  providedIn: 'root'
})
export class FavoriteOccupationsFacade {
  readonly favoriteOccupations$ = this.store.pipe(
    select(FavoriteOccupationsSelectors.selectFavoriteOccupations)
  );
  readonly favoriteOccupationCount$ = this.store.pipe(
    select(FavoriteOccupationsSelectors.selectFavoriteOccupationCount)
  );
  readonly isFavoriteOccupationsAtMaxCount$ = this.store.pipe(
    select(FavoriteOccupationsSelectors.selectIsFavoriteOccupationsAtMaxCount)
  );
  readonly isOccupationInFavorites$ = (onetCode: string, jobId: number) =>
    this.store.pipe(
      select(
        FavoriteOccupationsSelectors.selectIsOccupationInFavorites(
          onetCode,
          jobId
        )
      )
    );

  constructor(private store: Store<AppState>) {}

  addFavoriteOccupation(onetCode: string, jobId: number) {
    this.store.dispatch(
      FavoriteOccupationsActions.addFavoriteOccupation({ onetCode, jobId })
    );
  }

  removeFavoriteOccupation(onetCode: string, jobId: number) {
    this.store.dispatch(
      FavoriteOccupationsActions.removeFavoriteOccupation({ onetCode, jobId })
    );
  }
}
